import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { ResponseEventParams } from '@webapp/survey/src/entities/response-machine';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { MatrixApi } from './common/matrix';

export class MatrixDropdownListApi extends MatrixApi {
    public change(
        { id: questionId, answersActors, groupsActors, responseActor }: QuestionContext,
        { value }: ResponseEventParams,
    ): void {
        responseActor.send({ type: 'CHANGE', value, questionId });
        answersActors.forEach((answer) => {
            if (answer.getSnapshot().context.valid) {
                return;
            }
            let isAnswered = 0;
            groupsActors.forEach((groupActor) => {
                const group = groupActor.getSnapshot().context;
                if (group.responses[answer.id]?.getSnapshot().context.value) {
                    isAnswered += 1;
                }
            });
            if (isAnswered !== groupsActors.length) {
                answer.send({ type: 'SET_VALID', value: true });
            }
        });
    }

    public changeExtra(actor: QuestionActor, value: PrimitiveValue): void {
        const { response, id: questionId } = actor.getSnapshot().context;
        response.send({ type: 'CHANGE', value: !!value, questionId });
        super.changeExtra(actor, value);
    }

    public query = (actor: QuestionActor): AnswersRequest => {
        const { groupsActors, id: id, responseActor, answersActors } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        const answerIds = excludeHiddenAnswers(answersActors).map((a) => a.getSnapshot().context.id.toString());
        return {
            question: id,
            data: groupsActors.flatMap((groupActor) => {
                const { id: group, responses } = groupActor.getSnapshot().context;
                return Object.entries(responses)
                    .filter(
                        ([answerId, responseActor]) =>
                            responseActor.getSnapshot().context.value && answerIds.includes(answerId.toString()),
                    )
                    .map(([answerId, responseActor]) => {
                        const { extra, value } = responseActor.getSnapshot().context;

                        if (value === CANTRATE_ID) {
                            return {
                                group,
                                answer: parseInt(answerId),
                                bool: true,
                                cantRate: true,
                            };
                        }

                        return {
                            group,
                            bool: true,
                            answer: Number(answerId),
                            text: (extra as string) || (value as string),
                        };
                    });
            }),
            comment,
        };
    };
}
